/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetDocumentation Input Action
 */
export class GetDocumentationInput implements Msdyn365.IActionInput {
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `DEFAULT`;
    public getCacheObjectType = () => 'IGetDocumentationData';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetDocumentationData {
    blobs: { DocumentName: string; DocumentPosition: string }[];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetDocumentationInput();
};

export async function getDocumentation(input: GetDocumentationInput, ctx: Msdyn365.IActionContext): Promise<IGetDocumentationData> {
    const response = await fetch(`${ctx.requestContext.apiSettings.baseUrl}/Commerce/CatalogDocumentsList`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Oun: ctx.requestContext.apiSettings.oun
        },
        body: JSON.stringify({})
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const jsonResponse = await response.json();

    return { blobs: jsonResponse.value };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetDocumentationData>>getDocumentation,
    id: 'GetDocumentation',
    input: createInput
});
